import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Input, Button, Toastr } from "../../revvComponents";

import { extendEsignExpiryForDoc } from "../../actions/SettingsActions/settingsService";
import { GlobalUtils } from "../../utils";

const { handleApiErrMsg } = GlobalUtils;

class ExpirySettingPopup extends Component {
  state = {
    daysToChange: "",
    sendEmail: true,
    isSaving: false,
    disableSave: true,
  };

  _onDaysChange = e => {
    let disableSave = true;
    if (e.target.value && e.target.value > 0) {
      disableSave = false;
    }
    this.setState({ daysToChange: parseInt(e.target.value, 10), disableSave });
  };

  _onSendEmailChanged = e => {
    this.setState({ sendEmail: e.target.checked });
  };

  _save = () => {
    this.setState({ disableSave: true, isSaving: true });

    const payload = {
      flag: "expiry_extension_days",
      value: this.state.daysToChange,
      send_email: this.state.sendEmail,
    };
    extendEsignExpiryForDoc(this.props.docID, payload)
      .then(() => {
        const oldDate = moment(this.props.dateRaw);
        const now = moment.utc();
        const daysRemaining = oldDate
          .startOf("day")
          .diff(now.startOf("day"), "days");
        if (daysRemaining < 0) {
          const newDate = now.add(this.state.daysToChange, "days");
          this.props.onExpiryExtended(newDate);
        } else {
          const newDate = oldDate.add(this.state.daysToChange, "days");
          this.props.onExpiryExtended(newDate);
        }
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
        this.setState({ isSaving: false, disableSave: false });
      });
  };

  _daysRemainingText = () => {
    let daysRemainingText = `${this.props.daysRemaining} day(s) from now`;
    if (this.props.daysRemaining === 0) {
      daysRemainingText = `Today`;
    } else if (this.props.daysRemaining < 0) {
      daysRemainingText = `${Math.abs(this.props.daysRemaining)} day(s) ago`;
    }
    return daysRemainingText;
  };

  render() {
    return (
      <Modal
        open
        onClose={this.props.onClose}
        center
        closeOnOverlayClick={false}>
        <div className="esign-expiry-modal-container">
          <div className="esign-expiry-modal-heading">
            You’re about to extend the expiry date for this eSignature link
          </div>
          <hr />
          <div className="esign-expiry-modal-original-label">
            Original date of expiry
          </div>
          <div className="esign-expiry-modal-original-date">
            <FontAwesomeIcon
              icon={["far", "calendar-alt"]}
              className="esignexpirysettings-icon"
            />
            <span className="esign-expiry-modal-picker-date">
              {this.props.dateStr}
            </span>
            <span className="esign-expiry-modal-picker-days">
              {this._daysRemainingText()}
            </span>
          </div>
          <div className="esign-expiry-modal-days-extend-label">
            No. of days extending expiry
          </div>
          <div>
            <Input
              className="esign-expiry-modal-days-extend-input"
              id="check-esign-expiry-days"
              type="number"
              min="1"
              value={this.state.daysToChange}
              onChange={this._onDaysChange}
              data-test="assetcustomizecolumnpopup-input"
            />
          </div>
          <hr />
          <div>
            <Input
              className="esign-expiry-modal-send-email-checkbox"
              checked={this.state.sendEmail}
              id="check-esign-expiry-extension"
              type="checkbox"
              onChange={this._onSendEmailChanged}
              data-test="assetcustomizecolumnpopup-input"
            />
            <span className="esign-expiry-modal-send-email-text">
              Send a notification to the signers of this link about the
              extension
            </span>
          </div>
          <section className="createquotepopup-footer popup-footer clearfix">
            <div className="footer-actions">
              <Button
                className="btn btn-transparent createquotepopup-footer-cancelbtn"
                onClick={this.props.onCancel}
                data-test="esign-extend-expiry-cancel-btn">
                Cancel
              </Button>
              <Button
                className="btn btn-info"
                isLoading={this.state.isSaving}
                disabled={this.state.disableSave}
                onClick={this._save}
                data-test="esign-extend-expiry-create-btn">
                Extend expiration date
              </Button>
            </div>
          </section>
        </div>
      </Modal>
    );
  }
}
export default ExpirySettingPopup;
